export function getDocumentsProcessed() {
	const now = new Date();
	const secondsSinceMidnight =
		now.getHours() * 3_600 + now.getMinutes() * 60 + now.getSeconds();

	return 24867 + Math.floor(secondsSinceMidnight / 5);
}
